// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__25pHL","info":"PatientInfo_info__3Btxf"};